var exports = {
  "zr": "x93eb46d8--682995--root",
  "wl": "x93eb46d8--682995--main-text",
  "Vd": "x93eb46d8--682995--filters-list",
  "b5": "x93eb46d8--682995--filter-item",
  "Ih": "x93eb46d8--682995--filter-label",
};

module.exports = exports;
